import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { WHITE_LABEL_ACCENT_COLOR } from '../../../lib/white-label';

const CheckBoxWrapper = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr;
  grid-gap: 0 8px;
  cursor: pointer;
  align-items: center;

  .checkbox-text {
    font-weight: 600;
    font-size: 14px;
    line-height: 140%;
    color: #000000;
  }
  .checkbox-special-text {
    font-weight: 600;
    font-size: 14px;
    line-height: 140%;
    color: ${(props) => WHITE_LABEL_ACCENT_COLOR};;
`;

const CheckBoxContainer = styled.div<{ isChecked: boolean }>`
  height: 16px;
  width: 16px;
  background: #f2f4f9;
  border: 1px solid #dadde7;
  border-radius: 3px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  & > div {
    height: 10px;
    width: 10px;
    background: ${(props) => WHITE_LABEL_ACCENT_COLOR};
    border-radius: 3px;
    display: ${(props) => (props.isChecked ? 'block' : 'none')};
  }
  }
`;

interface CheckBoxProps {
  text: string;
  specialText: string;
  dataTour?: string;
  onChanged: (value: boolean) => void;
  onSpecialClicked?: (e: any) => void;
  checked?: boolean;
}

const CheckBox = ({
  text,
  specialText,
  dataTour,
  onChanged,
  onSpecialClicked,
  checked,
}: CheckBoxProps): JSX.Element => {
  const [isChecked, setIsChecked] = React.useState(
    typeof checked !== 'undefined' ? checked : false,
  );

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleToggle = () => {
    onChanged(!isChecked);
    setIsChecked(!isChecked);
  };
  return (
    <CheckBoxWrapper onClick={handleToggle} data-tour={dataTour}>
      <CheckBoxContainer isChecked={isChecked}>
        <div />
      </CheckBoxContainer>
      <p className="checkbox-text">
        {text}{' '}
        <span
          className="checkbox-special-text"
          onClick={(e) => {
            return onSpecialClicked ? onSpecialClicked(e) : null;
          }}
        >
          {specialText}
        </span>
      </p>
    </CheckBoxWrapper>
  );
};

export default CheckBox;
